import { format, parse } from 'date-fns';
import React, { useState } from 'react';

import { CONSTANTS } from '../../../core/config/constants';
import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';
import { useOnChange } from '../../../hooks/useOnChange';
import CalendarPickerInput from '../../Inputs/CalendarPicker/CalendarPickerInput';
import ReadableStatementView from '../../Inputs/ReadableStatementView';

export interface DatePickerFilter {
  value?: string;
}

interface Props {
  root: boolean;
  onChange: (value: DatePickerFilter) => void;
  defaultValue?: DatePickerFilter;
  active: boolean;
}

const defaultCalendarValue = { value: '' };

const DateFilterInput: React.FC<Props> = React.memo(
  ({ onChange, root, active, defaultValue = defaultCalendarValue }) => {
    const [state, setState] = useState<DatePickerFilter>(defaultValue);

    let defaultDatePickerValue;

    if (state.value) {
      defaultDatePickerValue = parse(state.value, CONSTANTS.DATE_FORMATS.API, new Date());
    }

    useDefaultValueWatcher({ defaultValue, state, setState });
    useOnChange(onChange, state, root);

    const rs: any[] = [];
    if (state.value) {
      rs.push({ label: 'Date:', value: state.value });
    }

    return (
      <>
        {active ? (
          <CalendarPickerInput
            defaultValue={defaultDatePickerValue}
            maxDate={new Date()}
            onChange={(date) => {
              if (date instanceof Date) {
                setState({
                  value: format(date, CONSTANTS.DATE_FORMATS.API),
                });
              } else {
                setState(defaultCalendarValue);
              }
            }}
          />
        ) : (
          <ReadableStatementView rows={rs} />
        )}
      </>
    );
  },
);

export default DateFilterInput;
